var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: "select",
      staticClass: "full-width",
      attrs: {
        "value-key": "value",
        "popper-class": _vm.classID,
        placeholder:
          _vm.remote && (!_vm.list || _vm.list.length == 0)
            ? _vm.$t("table.emptyText")
            : _vm.placeholder,
        multiple: _vm.multiple,
        disabled: _vm.disabled,
        filterable: "",
        clearable: _vm.clearable,
        size: _vm.size,
        "collapse-tags": _vm.collapseTags,
        remote: _vm.remote,
        "remote-method": _vm.remoteMethod,
        "no-data-text": _vm.$t("table.emptyText"),
        loading: _vm.loading,
      },
      on: { clear: _vm.remoteMethod, blur: _vm.onBlur, change: _vm.onChange },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    [
      _vm._l(_vm.defaultOptionsFilter, function (item, index) {
        return _c("el-option", {
          key: "defaultOptionsFilter_" + index,
          attrs: {
            label: item.label,
            value: item.value,
            disabled: item.disabled,
          },
        })
      }),
      _vm._l(_vm.list, function (item, index) {
        return _c("el-option", {
          key: index,
          attrs: {
            label: item.label,
            value: item.value,
            disabled: item.disabled,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }